import { atom } from "recoil";

export const staffStore = atom({
	key: "staffStore",
	default: {
		loaded: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		data: [],
		selectedItems: [],
		sorting: {
			sortingColumn: {
				sortingField: "login",
			},
			isDescending: false,
			sortingDescending: false,
			column: "login",
			order: "ASC",
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
			pages: 1,
			limit: 0,
		},
		filter: {
			brands: [],
			search: "",
			status: "active",
		},
		visibleProjects: [],
		visibleProjectsLoaded: false,
		visibleProjectsError: null,
		visibleProjectsLogin: null,
		reloadSignal: 0,
	},
});
